module.exports = __webpack_public_path__ + "img/esg-3.994e0ea3.png";